import axios from "axios";
import { toast } from "react-toastify";
import { invoiceDetailsUrl, invoicePaginatedUrl, invoiceFileDownloadUrl } from "../urls";
import { getToken , getTokenHeader} from "../../../../screen/auth/action";


export const getInvoicePaginatedAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(invoicePaginatedUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
export const downloadInvoiceFileAction = async (file_id, file_name, file_type) => {
  try {
    const token = await getToken();
    const response = await fetch(
      `${invoiceFileDownloadUrl()}/${file_id}?file_type=${file_type}`,
      { method: 'GET', ...getTokenHeader(token) }
    );
    const blob = await response.blob();
    if (blob.type.includes('application/json')) {
      toast.error('No Invoice File Found');
      return;
    }
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.setAttribute('download', file_name);
    a.click();
    URL.revokeObjectURL(a.href);
  } catch (err) {
    toast.error('Failed to download file');
  }
};

export const getInvoiceDetailsAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(invoiceDetailsUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};